module.exports = "/static/js/40e6ec020350bb01b93a5f8f1a14afa2.png";